var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  viewBox: "0 0 33 32",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.46183 16.4714L10.4047 15.5286C10.665 15.2682 11.0872 15.2682 11.3475 15.5286L13.9333 18.1143L21.8524 10.1952C22.1127 9.93487 22.5348 9.93487 22.7952 10.1952L23.738 11.138C23.9984 11.3984 23.9984 11.8205 23.738 12.0808L14.4047 21.4142C14.1443 21.6745 13.7222 21.6745 13.4618 21.4142L9.46183 17.4142C9.2015 17.1538 9.2015 16.7317 9.46183 16.4714Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.2666 16C3.2666 8.64808 9.24805 2.66663 16.5999 2.66663C23.9518 2.66663 29.9333 8.64808 29.9333 16C29.9333 23.3518 23.9518 29.3333 16.5999 29.3333C9.24805 29.3333 3.2666 23.3518 3.2666 16ZM5.93327 16C5.93327 10.1185 10.7184 5.33329 16.5999 5.33329C22.4814 5.33329 27.2666 10.1185 27.2666 16C27.2666 21.8815 22.4814 26.6666 16.5999 26.6666C10.7184 26.6666 5.93327 21.8815 5.93327 16Z",
  fill: "currentColor"
})));
export default SvgCheckCircle;